import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SSOResponseData } from '../model/response/sso-config.model';
import { ServerConfig } from '../model/response/server-config.model';

export const ssoLoginConfigPath = 'api/sso/login/saml';

@Injectable({
  providedIn: 'root'
})

export class SSOConfigService {
  //'https://hermes01.dev.accela.com:7080/api/sso/login/saml';
  apiUrl: string;
  
  constructor(private readonly http: HttpClient) {
  }

  getSSORedirectUrl(serverConfig: ServerConfig): Observable<SSOResponseData> {
    this.apiUrl = serverConfig.cloudAPIUrl + '/' + ssoLoginConfigPath + '?serviceProviderCode=' + serverConfig.servProvCode;
    var requestAPIModel = {
      "agency": serverConfig.servProvCode, 
      "application": "ACA",
      "environment": "HERMES"
    };
    
    let reqHeaders = new HttpHeaders()
      .append('tenantName', serverConfig.tenantName);
        
    return this.http.post(this.apiUrl, requestAPIModel, { headers: reqHeaders })
      .pipe(
        map((response: any) => {
          return response['result'] as SSOResponseData;
        })
      );
  }
  
}
